import { getAthleteAxiosInstance } from './authentication-service';

export const GetAthleteToken = async (athleteCred: any): Promise<any> => {
  const axiosInstance = await getAthleteAxiosInstance();
  if (!axiosInstance) {
    throw new Error('Failed to create Axios instance');
  }
  const idTokenRes = await axiosInstance.post('athlete/token/v1', {
    assertion: convertStringToBase64(
      `${athleteCred.country};${athleteCred.storeNumber};${athleteCred.employeeId}:${athleteCred.password}`,
    ),
    grant_type: 'nike:athlete:ID',
    client_id: 'nike.athlete.platform',
  });
  const bermPayload = makeBermPayload(idTokenRes.data.id_token);
  return axiosInstance.post('berm-internal/token/v1', bermPayload);
};

const convertStringToBase64 = (str: string): string => {
  return btoa(str);
};

const makeBermPayload = (idToken: string) => {
  const payload = {
    grant_type: 'nike:retail:exchange',
    assertion: idToken,
    client_id: 'nike.athlete.platform',
  };
  return JSON.stringify(payload);
};
